import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { MODEL_API_URL } from "../../../config";
import { ClientModelExternalEffect } from "../types";

export const useClientModelExternalEffects = (
  model_id: string,
  year: number
) => {
  return useQuery({
    queryKey: ["client", "external_effects", model_id, year],
    enabled: model_id.length > 0 && year > 0,
    queryFn: ({ signal }) =>
      axios
        .get(
          `${MODEL_API_URL}/waves-model-manager-api/v1/models/${model_id}/external_effects?year=${year}`,
          {
            signal
          }
        )
        .then((response) => {
          return response.data as ClientModelExternalEffect;
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
